import i18n from 'shared/lib/i18n';

export const getEventsCategories = () => [
  {
    label: i18n.t('events.categories.business_and_professional'),
    value: 'business_and_professional',
  },
  {
    label: i18n.t('events.categories.charity_and_causes'),
    value: 'charity_and_causes',
  },
  {
    label: i18n.t('events.categories.community_and_culture'),
    value: 'community_and_culture',
  },
  {
    label: i18n.t('events.categories.family_and_education'),
    value: 'family_and_education',
  },
  {
    label: i18n.t('events.categories.fashion_and_beauty'),
    value: 'fashion_and_beauty',
  },
  {
    label: i18n.t('events.categories.media_and_entertainment'),
    value: 'media_and_entertainment',
  },
  {
    label: i18n.t('events.categories.food_and_drink'),
    value: 'food_and_drink',
  },
  {
    label: i18n.t('events.categories.health_and_wellness'),
    value: 'health_and_wellness',
  },
  {
    label: i18n.t('events.categories.hobbies_and_special_interest'),
    value: 'hobbies_and_special_interest',
  },
  {
    label: i18n.t('events.categories.home_and_lifestyle'),
    value: 'home_and_lifestyle',
  },
  {
    label: i18n.t('events.categories.performing_and_visual_arts'),
    value: 'performing_and_visual_arts',
  },
  {
    label: i18n.t('events.categories.science_and_technology'),
    value: 'science_and_technology',
  },
  {
    label: i18n.t('events.categories.seasonal_and_holiday'),
    value: 'seasonal_and_holiday',
  },
  {
    label: i18n.t('events.categories.sports_and_fitness'),
    value: 'sports_and_fitness',
  },
  {
    label: i18n.t('events.categories.travel_and_outdoor'),
    value: 'travel_and_outdoor',
  },
  { label: i18n.t('common.other'), value: 'other' },
];
